import type {Author} from "~/graphql/__generated__/graphql"
import type AuthorLocal from "~/libs/interfaces/AuthorLocal"

const authorLocalFactory = {
  createAuthorLocal(author: Author): AuthorLocal {
    return {
      ...author,
      isVisible: true
    }
  }
}
export default authorLocalFactory
